module.exports = __webpack_public_path__ + "img/stock2.3dfd0dbc.png";